import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomerListGroup = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 64,
	viewBox: "0 0 45 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M44.9016 5.13792L0.568911 4.82568C0.479294 4.82568 0.406479 4.89749 0.405679 4.98785L0 63.5233C0 63.6137 0.0712139 63.6871 0.160831 63.6879L44.4303 64.0002C44.5199 64.0002 44.5927 63.9284 44.5935 63.838L45 5.23877C45 5.18391 44.9568 5.13872 44.9016 5.13872V5.13792Z",
			fill: "#2E2E46"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.3257 6.36475H1.67676V61.9514H43.3257V6.36475Z",
			fill: "#E3E7F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.1562 3.33783L25.5157 3.29104C25.5245 3.20148 25.5309 3.11031 25.5309 3.01834C25.5429 1.36277 24.221 0.0113666 22.5791 7.13076e-05C20.9372 -0.011224 19.5969 1.32082 19.5857 2.97638C19.5857 3.06836 19.5897 3.15872 19.5977 3.24908L12.9572 3.20229C11.6914 3.19342 10.6584 4.22048 10.6496 5.49685L10.6279 8.64743C10.6255 8.94273 10.8616 9.18315 11.1536 9.18557L33.8773 9.34613C34.1701 9.34855 34.4086 9.11054 34.411 8.81606L34.4326 5.66547C34.4414 4.3891 33.4228 3.34752 32.157 3.33864L32.1562 3.33783ZM22.5447 4.90546C21.4997 4.8982 20.6587 4.03814 20.6659 2.98445C20.6731 1.93076 21.5261 1.08281 22.5711 1.09007C23.6161 1.09733 24.4571 1.95739 24.4499 3.01108C24.4426 4.06477 23.5897 4.91272 22.5447 4.90546Z",
			fill: "url(#paint0_linear_5402_211896)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.216 14.0708H32.9837C32.9933 14.0708 33.0005 14.0781 33.0005 14.0877V14.5355C33.0005 14.5452 32.9933 14.5525 32.9837 14.5525H14.216C14.2064 14.5525 14.1992 14.5452 14.1992 14.5355V14.0877C14.1992 14.0781 14.2064 14.0708 14.216 14.0708Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9837 17.9268H14.216C14.2067 17.9268 14.1992 17.9343 14.1992 17.9437V18.3915C14.1992 18.4008 14.2067 18.4084 14.216 18.4084H32.9837C32.993 18.4084 33.0005 18.4008 33.0005 18.3915V17.9437C33.0005 17.9343 32.993 17.9268 32.9837 17.9268Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.1539 15.999H14.216C14.2067 15.999 14.1992 16.0066 14.1992 16.016V16.4637C14.1992 16.4731 14.2067 16.4807 14.216 16.4807H40.1539C40.1632 16.4807 40.1707 16.4731 40.1707 16.4637V16.016C40.1707 16.0066 40.1632 15.999 40.1539 15.999Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.128 18.9481H6.71018C6.59096 18.9481 6.49414 18.8504 6.49414 18.7302V13.2681C6.49414 13.1479 6.59096 13.0503 6.71018 13.0503H12.1272C12.2465 13.0503 12.3433 13.1479 12.3433 13.2681V18.7302C12.3433 18.8504 12.2465 18.9481 12.1272 18.9481H12.128ZM6.92702 18.5124H11.912V13.486H6.92702V18.5124Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9837 25.5024H14.216C14.2067 25.5024 14.1992 25.51 14.1992 25.5194V25.9672C14.1992 25.9765 14.2067 25.9841 14.216 25.9841H32.9837C32.993 25.9841 33.0005 25.9765 33.0005 25.9672V25.5194C33.0005 25.51 32.993 25.5024 32.9837 25.5024Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.1539 27.4307H14.216C14.2067 27.4307 14.1992 27.4383 14.1992 27.4476V27.8954C14.1992 27.9047 14.2067 27.9123 14.216 27.9123H40.1539C40.1632 27.9123 40.1707 27.9047 40.1707 27.8954V27.4476C40.1707 27.4383 40.1632 27.4307 40.1539 27.4307Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.128 30.3797H6.71018C6.59096 30.3797 6.49414 30.2821 6.49414 30.1619V24.6998C6.49414 24.5796 6.59096 24.4819 6.71018 24.4819H12.1272C12.2465 24.4819 12.3433 24.5796 12.3433 24.6998V30.1619C12.3433 30.2821 12.2465 30.3797 12.1272 30.3797H12.128ZM6.92702 29.9432H11.912V24.9168H6.92702V29.9432Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.216 50.1274H32.9837C32.9933 50.1274 33.0005 50.1347 33.0005 50.1444V50.5922C33.0005 50.6018 32.9933 50.6091 32.9837 50.6091H14.216C14.2064 50.6091 14.1992 50.6018 14.1992 50.5922V50.1444C14.1992 50.1347 14.2064 50.1274 14.216 50.1274Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9837 53.9834H14.216C14.2067 53.9834 14.1992 53.991 14.1992 54.0003V54.4481C14.1992 54.4575 14.2067 54.4651 14.216 54.4651H32.9837C32.993 54.4651 33.0005 54.4575 33.0005 54.4481V54.0003C33.0005 53.991 32.993 53.9834 32.9837 53.9834Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.1539 52.0552H14.216C14.2067 52.0552 14.1992 52.0628 14.1992 52.0721V52.5199C14.1992 52.5293 14.2067 52.5368 14.216 52.5368H40.1539C40.1632 52.5368 40.1707 52.5293 40.1707 52.5199V52.0721C40.1707 52.0628 40.1632 52.0552 40.1539 52.0552Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.128 55.0047H6.71018C6.59096 55.0047 6.49414 54.9071 6.49414 54.7869V49.3248C6.49414 49.2046 6.59096 49.1069 6.71018 49.1069H12.1272C12.2465 49.1069 12.3433 49.2046 12.3433 49.3248V54.7869C12.3433 54.9071 12.2465 55.0047 12.1272 55.0047H12.128ZM6.92702 54.5682H11.912V49.5418H6.92702V54.5682Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9837 40.0889H14.216C14.2067 40.0889 14.1992 40.0965 14.1992 40.1058V40.5536C14.1992 40.5629 14.2067 40.5705 14.216 40.5705H32.9837C32.993 40.5705 33.0005 40.5629 33.0005 40.5536V40.1058C33.0005 40.0965 32.993 40.0889 32.9837 40.0889Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.216 38.1611H40.1531C40.1627 38.1611 40.1699 38.1684 40.1699 38.1781V38.6259C40.1699 38.6355 40.1627 38.6428 40.1531 38.6428H14.216C14.2064 38.6428 14.1992 38.6355 14.1992 38.6259V38.1781C14.1992 38.1684 14.2064 38.1611 14.216 38.1611Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.128 42.3953H6.71018C6.59096 42.3953 6.49414 42.2977 6.49414 42.1775V36.7154C6.49414 36.5952 6.59096 36.4976 6.71018 36.4976H12.1272C12.2465 36.4976 12.3433 36.5952 12.3433 36.7154V42.1775C12.3433 42.2977 12.2465 42.3953 12.1272 42.3953H12.128ZM6.92702 41.9596H11.912V36.9332H6.92702V41.9596Z",
			fill: "#A4B2DB"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_5402_211896",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 11,
			width: 9,
			height: 10,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.2462 12.0082L5.73535 11.9526L5.67318 20.5038L13.184 20.5593L13.2462 12.0082Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_5402_211896)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5172 11.0317L4.87012 10.9678L4.79979 20.6419L13.4468 20.7059L13.5172 11.0317Z",
					fill: "url(#paint1_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.88206 12.4925C9.94528 12.4941 10.0141 12.4973 10.0621 12.5385C10.1189 12.5869 10.1277 12.67 10.1597 12.7378C10.2509 12.933 10.5022 12.9726 10.7134 13.0113C10.9247 13.05 11.1751 13.1678 11.1727 13.384C11.1727 13.4332 11.1575 13.4841 11.1743 13.5309C11.1847 13.5607 11.2071 13.5841 11.2311 13.6059C11.3768 13.7374 11.572 13.7939 11.74 13.8931C11.9081 13.9924 12.0617 14.1739 12.0217 14.3667C12.0025 14.4571 11.9433 14.5362 11.9313 14.6273C11.9121 14.7725 12.0137 14.9024 12.1097 15.013L12.6466 15.6334C12.7178 15.7157 12.7922 15.8061 12.801 15.915C12.817 16.1127 12.6154 16.2603 12.5722 16.4531C12.5186 16.6903 12.7114 16.9074 12.7642 17.1446C12.8346 17.4624 12.605 17.815 12.2873 17.8755C12.2137 17.8892 12.1337 17.8917 12.0729 17.9352C11.9745 18.0062 11.9705 18.1474 11.9481 18.2676C11.8993 18.525 11.7096 18.7509 11.4656 18.8421C10.9863 19.022 10.475 18.6912 9.96448 18.6525C9.65322 18.6291 9.34516 18.7154 9.0339 18.7307C8.67063 18.7485 8.30256 18.6678 7.98009 18.4984C7.94409 18.479 7.90728 18.4588 7.88167 18.4266C7.81766 18.3475 7.84167 18.2321 7.82806 18.1305C7.78726 17.8295 7.43679 17.6972 7.14153 17.6367C6.84707 17.5762 6.495 17.4802 6.40939 17.1889C6.36458 17.0348 6.41179 16.863 6.35818 16.7121C6.29256 16.529 6.09892 16.4257 6.00211 16.2571C5.86768 16.0239 5.9493 15.7254 6.06932 15.4833C6.18854 15.2421 6.34697 15.0057 6.36218 14.7362C6.37178 14.5579 6.31737 14.3829 6.30376 14.2046C6.29016 14.0262 6.33177 13.8237 6.4798 13.7261C6.65983 13.6067 6.90308 13.6955 7.11352 13.647C7.60642 13.5341 7.72484 12.7523 8.22254 12.6668C8.32016 12.6498 8.42018 12.6644 8.5194 12.6692C8.78585 12.6813 8.98589 12.5893 9.23314 12.5199C9.44278 12.461 9.66202 12.4877 9.88126 12.4933L9.88206 12.4925Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1562 17.498C10.1562 17.498 12.2166 18.1701 12.5255 18.5921C12.8344 19.0132 13.1792 21.1545 13.1792 21.1545L6.02344 20.8503C6.02344 20.8503 6.41391 18.6316 7.02043 18.154C7.62695 17.6764 9.08244 17.5828 9.08244 17.5828L10.157 17.4997L10.1562 17.498Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.77707 15.2139C7.77707 15.2139 7.62984 15.0493 7.54582 15.1381C7.33298 15.3648 7.61063 15.5713 7.78027 15.6004L7.77707 15.2131V15.2139Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.62162 14.5485H7.62322C7.62002 14.5291 7.61602 14.5106 7.61282 14.4912C7.48399 13.636 8.09691 12.8397 8.96588 12.7646C9.69002 12.7025 10.363 13.1882 10.5382 13.8998C10.603 14.1636 10.595 14.425 10.5286 14.6663C10.423 15.1294 10.3301 15.5094 10.2061 15.8135C10.0005 16.3154 9.97088 16.8729 10.1261 17.3925L10.1557 17.4982C9.36196 18.0621 8.90987 17.6442 8.90987 17.6442L8.80505 16.9463C8.79145 16.8559 8.71783 16.7857 8.62661 16.7793C7.64802 16.7075 7.69443 15.0358 7.62082 14.5493L7.62162 14.5485Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.37012 15.9985C8.37012 15.9985 8.47974 15.9178 8.54535 15.9364C8.61096 15.9549 8.64697 16.0348 8.64697 16.0348C8.64697 16.0348 8.68618 15.9549 8.76619 15.9541C8.84621 15.9533 9.07025 16.0154 9.07025 16.0154C9.07025 16.0154 8.86221 16.3583 8.62377 16.2978C8.38532 16.2373 8.37332 16.0106 8.37332 16.0106L8.37012 15.9993V15.9985Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.19123 15.1043C9.17843 15.0204 9.23604 14.9429 9.31846 14.93C9.40168 14.9171 9.47849 14.9752 9.49129 15.0583C9.5041 15.1422 9.44648 15.2197 9.36407 15.2326C9.28085 15.2455 9.20404 15.1874 9.19123 15.1043Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.97248 15.097C7.95968 15.0131 8.01729 14.9356 8.09971 14.9227C8.18293 14.9098 8.25974 14.9679 8.27254 15.051C8.28535 15.1349 8.22773 15.2123 8.14532 15.2252C8.0621 15.2382 7.98529 15.1801 7.97248 15.097Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.59427 16.1387C8.86872 16.1976 9.13518 15.9943 9.13838 15.991C9.14638 15.9846 9.14798 15.9733 9.14158 15.9652C9.13518 15.9572 9.12397 15.9555 9.11597 15.962C9.09837 15.9757 8.68229 16.2928 8.37183 15.9701C8.36462 15.9628 8.35342 15.9628 8.34622 15.9701C8.33902 15.9773 8.33902 15.9886 8.34622 15.9959C8.42464 16.0774 8.50945 16.1201 8.59427 16.1387Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.62774 14.7318C9.64214 14.7278 9.65494 14.7165 9.66135 14.7012C9.67335 14.6737 9.66135 14.6423 9.63334 14.6302C9.62534 14.6269 9.4309 14.5454 9.20446 14.6237C9.17645 14.6334 9.16125 14.664 9.17085 14.6923C9.18045 14.7205 9.21326 14.735 9.23886 14.7262C9.4277 14.6608 9.58933 14.7286 9.59093 14.7294C9.60293 14.7342 9.61574 14.735 9.62694 14.7318H9.62774Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.26641 14.7405C8.28081 14.7364 8.29362 14.7251 8.30002 14.7098C8.31202 14.6824 8.30002 14.6509 8.27201 14.6388C8.26401 14.6356 8.07117 14.5533 7.84313 14.6324C7.81512 14.642 7.79992 14.6727 7.80952 14.7009C7.81912 14.7292 7.85033 14.7437 7.87754 14.7348C8.06637 14.6695 8.228 14.7381 8.2296 14.7381C8.24161 14.7429 8.25441 14.7437 8.26561 14.7405H8.26641Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.65814 15.6644C8.70935 15.6491 8.74056 15.6233 8.74136 15.6224C8.75256 15.6128 8.75416 15.5958 8.74456 15.5845C8.73496 15.5732 8.71815 15.5716 8.70695 15.5813C8.70215 15.5853 8.59573 15.6709 8.4645 15.5813C8.4389 15.5636 8.4317 15.5523 8.4309 15.5458C8.4285 15.5329 8.4437 15.5103 8.4637 15.4821C8.51251 15.4119 8.59333 15.2941 8.59013 15.0545C8.59013 15.0399 8.57813 15.0278 8.56292 15.0278C8.54772 15.0278 8.53652 15.0399 8.53652 15.0553C8.53892 15.2771 8.46691 15.382 8.4197 15.4514C8.39329 15.4901 8.37169 15.5208 8.37809 15.5555C8.38289 15.5805 8.39969 15.6023 8.4349 15.6257C8.52212 15.6854 8.60133 15.6822 8.65814 15.6652V15.6644Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1 15.0689C10.0695 14.9955 10.0727 14.9116 10.0399 14.8398C9.95672 14.6566 9.70707 14.6405 9.54864 14.5179C9.3534 14.367 9.29979 14.054 9.07015 13.9652C8.96853 13.9257 8.84371 13.9378 8.76209 13.8652C8.70288 13.8127 8.68367 13.7296 8.65087 13.657C8.61806 13.5844 8.55325 13.5118 8.47483 13.5231C8.43963 13.5279 8.40842 13.5497 8.38282 13.5747C8.20758 13.7393 8.18518 14.0411 7.97954 14.1645C7.91392 14.204 7.83631 14.2194 7.76509 14.2484C7.56666 14.3275 7.41383 14.5147 7.37542 14.726C7.22179 14.626 7.20018 14.4001 7.261 14.2266C7.32181 14.0524 7.44343 13.9079 7.52905 13.7442C7.61386 13.5812 7.66107 13.4004 7.74109 13.2351C7.82111 13.0697 7.94433 12.9115 8.11876 12.8559C8.26279 12.8099 8.41962 12.8397 8.56925 12.8171C8.70048 12.797 8.8213 12.7373 8.94853 12.6993C9.3182 12.588 9.73988 12.6719 10.0391 12.9164C10.1448 13.0027 10.2352 13.1068 10.3248 13.21C10.5248 13.4408 10.7249 13.6715 10.9249 13.9015C11.0209 14.012 11.1202 14.1282 11.1594 14.2694C11.2266 14.5106 11.1081 14.7599 10.9929 14.9818C10.9369 15.0899 10.8673 15.2093 10.7489 15.2384C10.5256 15.2924 10.2096 15.3295 10.1008 15.0665L10.1 15.0689Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1419 15.1519C10.1587 15.1003 10.1947 15.0567 10.2411 15.0293C10.3372 14.972 10.51 14.8994 10.6524 15.0051C10.8613 15.16 10.5692 15.7005 10.1723 15.515C10.1723 15.515 10.0539 15.427 10.1419 15.1519Z",
					fill: "#FFCDC4"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_5402_211896",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 23,
			width: 9,
			height: 9,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.1956 23.1577H5.68457V31.7091H13.1956V23.1577Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask1_5402_211896)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4588 22.1797H4.81152V31.8541H13.4588V22.1797Z",
					fill: "url(#paint2_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1466 28.6697C10.1466 28.6697 12.2118 29.3265 12.5238 29.746C12.8359 30.1656 13.196 32.3028 13.196 32.3028L5.46484 32.0309C5.46484 32.0309 6.41303 29.8291 7.01555 29.3474C7.61806 28.865 8.90392 28.6665 8.90392 28.6665L10.1474 28.6697H10.1466Z",
					fill: "url(#paint3_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.65227 30.5561C7.65227 30.5561 7.91953 29.7775 7.98274 29.5161C8.04595 29.2547 8.2996 29.0489 8.17078 28.9634C8.04195 28.8779 7.73309 29.291 7.73309 29.291C7.73309 29.291 7.60827 28.7585 7.59386 28.5891C7.58026 28.4196 7.47864 28.1227 7.35542 28.1235C7.23139 28.1235 7.35462 28.9336 7.35462 28.9336C7.35462 28.9336 7.18498 28.2623 7.07056 28.2381C6.95614 28.2139 7.04816 29.0998 7.04816 29.0998C7.04816 29.0998 6.90173 28.3745 6.84091 28.3285C6.7801 28.2817 6.71849 28.3583 6.70889 28.6278C6.69929 28.8973 6.7577 29.1748 6.7577 29.1748C6.7577 29.1748 6.61687 28.673 6.57926 28.6189C6.54166 28.5649 6.45044 28.5181 6.47764 28.9182C6.50485 29.3184 6.70329 30.1752 6.97454 30.5625L7.65307 30.5561H7.65227Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.96106 26.2549C7.96106 26.2549 7.84504 26.0766 7.75222 26.1492C7.51697 26.3332 7.75062 26.5704 7.90745 26.6236L7.96106 26.2549Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.91116 25.5999H7.91276C7.91276 25.5814 7.91116 25.5628 7.91116 25.5443C7.91356 24.7124 8.61129 24.046 9.44826 24.1041C10.1452 24.1525 10.7141 24.7141 10.7773 25.416C10.8005 25.6766 10.7549 25.9243 10.6573 26.1429C10.5237 26.481 10.4052 26.7706 10.2804 27.011C10.074 27.4088 10.0076 27.8655 10.0812 28.3084L10.1388 28.6569C9.25462 29.1281 8.85374 28.686 8.85374 28.686L8.83934 28.047C8.83774 27.9639 8.77212 27.8961 8.68971 27.8905H8.68811C7.59429 27.8154 7.91036 26.0977 7.91116 25.6007V25.5999Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.45117 26.3669C9.45117 26.2942 9.51038 26.2354 9.5824 26.2354C9.65441 26.2354 9.71282 26.2951 9.71282 26.3677C9.71282 26.4403 9.65361 26.4992 9.5816 26.4992C9.50958 26.4992 9.45117 26.4395 9.45117 26.3669Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.17383 26.175C8.17383 26.1024 8.23304 26.0435 8.30505 26.0435C8.37707 26.0435 8.43548 26.1032 8.43548 26.1758C8.43548 26.2484 8.37627 26.3073 8.30425 26.3073C8.23224 26.3073 8.17383 26.2476 8.17383 26.175Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.87999 26.1508C9.89359 26.1525 9.90799 26.1508 9.9216 26.1452C9.9616 26.1282 9.98001 26.0823 9.9632 26.0419C9.91279 25.9209 9.73276 25.72 9.4159 25.8265C9.37509 25.8402 9.35268 25.8854 9.36629 25.9265C9.37989 25.9677 9.4247 25.9903 9.46551 25.9766C9.72636 25.8886 9.81517 26.0944 9.81918 26.1032C9.83038 26.1299 9.85438 26.1468 9.87999 26.1508Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.587 25.8449C8.6006 25.8417 8.6134 25.8353 8.6238 25.8248C8.65501 25.7941 8.65581 25.7441 8.62541 25.7134C8.53499 25.619 8.29494 25.4972 8.03809 25.7134C8.00448 25.7417 8.00048 25.7909 8.02769 25.8248C8.05569 25.8587 8.1045 25.8627 8.13811 25.8353C8.34935 25.6578 8.50698 25.8175 8.51338 25.824C8.53339 25.8449 8.56139 25.8522 8.5878 25.8458L8.587 25.8449Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.9032 25.6741L10.5192 26.631L10.2583 26.5777L10.1055 25.3135L10.9032 25.6741Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.2174 26.5464C10.2406 26.4996 10.2814 26.4641 10.3294 26.4447C10.4286 26.4044 10.6039 26.3608 10.7239 26.4826C10.8999 26.6609 10.5439 27.1313 10.1934 26.8957C10.1934 26.8957 10.0934 26.7941 10.2174 26.5464Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.69919 26.8505C8.82722 26.9143 8.94164 26.8449 8.94324 26.8441C8.95444 26.8376 8.95764 26.8231 8.95044 26.8118C8.94404 26.8005 8.92964 26.7973 8.91844 26.8037C8.91284 26.807 8.78561 26.8828 8.65839 26.7658C8.63758 26.7464 8.62718 26.7311 8.62638 26.7198C8.62638 26.7037 8.64478 26.6827 8.67119 26.6545C8.732 26.5883 8.83442 26.4786 8.86643 26.2285C8.86803 26.2156 8.85923 26.2035 8.84642 26.2018C8.83362 26.2002 8.82242 26.2091 8.82002 26.222C8.78961 26.4568 8.69759 26.556 8.63678 26.6222C8.60398 26.6577 8.57757 26.6859 8.57917 26.7214C8.57997 26.7464 8.59437 26.7715 8.62638 26.8005C8.65038 26.8223 8.67439 26.8392 8.69839 26.8505H8.69919Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.14302 25.0374C8.14302 25.0374 7.93658 25.1826 7.88297 26.062C7.88297 26.062 7.81575 25.0826 7.92378 24.9745C8.0318 24.8672 8.14302 25.0374 8.14302 25.0374Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.003 25.7886C11.0438 25.7257 11.0334 25.6337 10.9798 25.5821C11.0702 25.5159 11.0758 25.361 10.9894 25.2892C10.9686 25.2715 10.9438 25.2594 10.9246 25.24C10.8942 25.2093 10.8806 25.1658 10.871 25.123C10.851 25.0335 10.8414 24.9423 10.8446 24.8503C10.8462 24.793 10.851 24.7317 10.8206 24.6841C10.779 24.6196 10.6877 24.605 10.6421 24.5437C10.5885 24.4703 10.6133 24.3469 10.5381 24.296C10.4981 24.2686 10.4461 24.2743 10.3997 24.263C10.2533 24.2267 10.1828 24.0338 10.034 24.0064C9.98681 23.9975 9.9388 24.0072 9.89079 24.008C9.74836 24.0096 9.61954 23.9289 9.48511 23.8805C9.35069 23.8321 9.17705 23.8249 9.08983 23.9378C9.07383 23.9588 9.06103 23.9838 9.03862 23.9983C9.00822 24.0193 8.96821 24.0177 8.9314 24.0128C8.83378 23.9999 8.73777 23.9741 8.63935 23.9773C8.54093 23.9806 8.43691 24.0201 8.3889 24.1064C8.37289 24.1347 8.36409 24.1669 8.34169 24.1895C8.31608 24.2162 8.27768 24.2266 8.24167 24.2331C8.09604 24.2597 7.9144 24.2767 7.85919 24.4154C7.81759 24.5203 7.8712 24.6591 7.79438 24.7414C7.76638 24.7712 7.72557 24.7866 7.69516 24.8148C7.61755 24.889 7.64795 25.0302 7.73197 25.0964C7.81598 25.1625 7.93201 25.1698 8.03843 25.1577C8.14485 25.1464 8.25047 25.119 8.35689 25.127C8.3857 25.1295 8.4177 25.1359 8.43291 25.1609C8.44331 25.1779 8.44331 25.1997 8.44571 25.219C8.45611 25.3054 8.52812 25.3755 8.60894 25.407C8.68976 25.4385 8.77857 25.4385 8.86579 25.4344C9.01782 25.4272 9.16985 25.4078 9.31868 25.3764C9.4339 25.3521 9.55232 25.3215 9.66755 25.3433C9.74836 25.3586 9.82278 25.3989 9.89639 25.4352C10.0156 25.4941 10.1388 25.545 10.2621 25.5958L10.3685 25.6394C10.5085 25.6967 10.8886 25.9653 11.0038 25.7894L11.003 25.7886Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.33496 27.0474L9.16952 27.149C9.16952 27.149 8.69103 27.9631 8.33496 27.0474Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.79369 30.563H7.81869L7.97152 32.4493L5.91992 32.1976L6.79369 30.563Z",
					fill: "url(#paint4_linear_5402_211896)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_5402_211896",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 34,
			width: 9,
			height: 9,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.1956 34.374H5.68457V42.9254H13.1956V34.374Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask2_5402_211896)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4588 33.396H4.81152V43.0704H13.4588V33.396Z",
					fill: "#83CAF9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.83398 40.7427C5.84519 41.1493 6.33008 41.4882 6.19725 41.8722C6.16765 41.9577 6.10924 42.0311 6.08523 42.1183C6.03322 42.3095 6.17485 42.5152 6.35969 42.5854C6.54372 42.6556 6.75336 42.6161 6.935 42.5394C7.11663 42.4628 7.28227 42.3514 7.4615 42.2692C7.86398 42.0844 8.31607 42.057 8.74895 41.9706C9.18904 41.8835 9.62593 41.7334 10.0724 41.7649C10.5877 41.8012 11.0526 42.0731 11.5359 42.2595C12.028 42.4491 12.5529 42.5523 13.0794 42.562C13.3539 42.5669 13.6387 42.5451 13.8828 42.4168C14.3693 42.161 14.5573 41.5245 14.3621 41.0226C14.2508 40.7362 14.0292 40.5022 13.7651 40.353C13.5291 40.2199 13.2274 40.1755 13.0498 39.9528C12.8001 39.6414 12.953 39.1751 12.8546 38.787C12.7713 38.4602 12.4993 38.1924 12.1976 38.0625C11.916 37.9414 11.5663 37.9245 11.3551 37.6744C11.1254 37.4033 11.2014 37.0273 11.1606 36.7022C11.1014 36.2367 10.795 35.8244 10.3997 35.5759C10.2821 35.5017 10.154 35.4395 10.0196 35.3895C9.13223 35.0611 7.9768 35.2879 7.66554 36.3101C7.57032 36.6231 7.57672 36.9741 7.40709 37.2532C7.22226 37.5566 6.85098 37.7365 6.74856 38.077C6.61974 38.5054 6.98381 38.9653 6.86379 39.3961C6.78537 39.6777 6.52452 39.86 6.29407 40.0367C6.06283 40.2142 5.82678 40.4498 5.83478 40.7419L5.83398 40.7427Z",
					fill: "url(#paint5_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1466 39.886C10.1466 39.886 12.2118 40.5428 12.5238 40.9623C12.8359 41.3819 13.196 43.5191 13.196 43.5191L5.46484 43.2472C5.46484 43.2472 6.41303 41.0454 7.01555 40.5638C7.61806 40.0813 8.90392 39.8828 8.90392 39.8828L10.1474 39.886H10.1466Z",
					fill: "url(#paint6_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.85435 37.7561C7.85435 37.7561 7.71033 37.5955 7.62871 37.6827C7.42067 37.9037 7.71273 38.1103 7.87836 38.1393L7.85435 37.7561Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.0145 35.3632C9.74425 35.3003 10.4172 35.8069 10.5652 36.5306C10.614 36.7686 10.6028 37.0034 10.5428 37.2205C10.4204 37.7578 10.3172 38.1902 10.1571 38.5194C9.99549 38.8526 9.95549 39.2318 10.0611 39.5868L10.1683 39.945C9.39298 40.4969 8.96169 40.1298 8.96169 40.1298L8.83447 39.2835C7.91029 39.3133 7.77666 37.6053 7.70145 37.1067H7.70305C7.69984 37.0881 7.69584 37.0696 7.69344 37.051C7.56782 36.2152 8.16554 35.4374 9.0145 35.364V35.3632Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.34106 36.8272C9.5451 36.9813 9.72913 37.1604 9.91237 37.3387C10.1068 37.5275 10.3084 37.7284 10.3845 37.989C10.5917 37.7735 10.7013 37.4831 10.7869 37.1959C10.8269 37.0627 10.863 36.9264 10.8622 36.7876C10.8606 36.5908 10.7845 36.4036 10.7093 36.2212C10.6125 35.9865 10.5085 35.7428 10.3156 35.579C10.1876 35.4709 10.0292 35.4064 9.86916 35.3588C9.49549 35.249 9.09061 35.2281 8.71694 35.3402C8.34406 35.4524 8.0064 35.7041 7.82556 36.0526C7.59352 36.5004 7.64073 37.0377 7.69434 37.5404C7.71274 37.3258 7.82236 37.1313 7.92958 36.9441C7.9992 36.8223 8.07121 36.6989 8.17603 36.6069C8.35607 36.4504 8.41528 36.4697 8.72814 36.1785C8.86577 36.4722 9.08421 36.6327 9.33946 36.8263L9.34106 36.8272Z",
					fill: "url(#paint7_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1648 37.6945C10.1808 37.6437 10.216 37.6017 10.2616 37.5751C10.3552 37.5194 10.5241 37.4484 10.6633 37.5517C10.8673 37.7034 10.5825 38.231 10.1944 38.0503C10.1944 38.0503 10.0784 37.964 10.1648 37.6953V37.6945Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.09584 37.7325C8.07823 37.664 8.11984 37.5938 8.18786 37.5768C8.25587 37.5591 8.32548 37.601 8.34229 37.6696C8.35989 37.7382 8.31828 37.8084 8.25027 37.8253C8.18225 37.8431 8.11264 37.8011 8.09584 37.7325Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.30384 37.6852C9.28624 37.6166 9.32785 37.5464 9.39586 37.5295C9.46388 37.5117 9.53349 37.5537 9.55029 37.6222C9.5679 37.6908 9.52629 37.761 9.45828 37.778C9.39026 37.7957 9.32065 37.7538 9.30384 37.6852Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.50781 38.609C8.50781 38.609 8.60783 38.5186 8.67425 38.5307C8.74066 38.5428 8.78387 38.6179 8.78387 38.6179C8.78387 38.6179 8.81507 38.5356 8.89349 38.5267C8.9719 38.5178 9.19915 38.5573 9.19915 38.5573C9.19915 38.5573 9.02711 38.9156 8.78627 38.8785C8.54542 38.8422 8.51261 38.6195 8.51261 38.6195L8.50781 38.6082V38.609Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.74168 38.7256C9.01694 38.7571 9.26098 38.5312 9.26418 38.528C9.27138 38.5215 9.27138 38.5094 9.26418 38.5021C9.25778 38.4949 9.24578 38.4949 9.23858 38.5013C9.22258 38.5167 8.8425 38.8684 8.50644 38.5812C8.49923 38.5747 8.48723 38.5756 8.48083 38.5836C8.47443 38.5909 8.47523 38.603 8.48323 38.6094C8.56805 38.6821 8.65606 38.7159 8.74088 38.7256H8.74168Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.69029 37.4398C9.70549 37.4365 9.7183 37.4268 9.7263 37.4123C9.7399 37.3865 9.7303 37.3542 9.70469 37.3397C9.69669 37.3357 9.51186 37.2389 9.28221 37.2978C9.2542 37.305 9.2366 37.3341 9.2438 37.3623C9.251 37.3905 9.28221 37.4083 9.30782 37.401C9.49905 37.3526 9.65348 37.4333 9.65508 37.4341C9.66629 37.4406 9.67909 37.4414 9.69109 37.439L9.69029 37.4398Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.37632 37.4162C8.39072 37.4106 8.40193 37.3985 8.40673 37.3831C8.41553 37.3549 8.40033 37.3251 8.37232 37.3162C8.36432 37.3138 8.16668 37.2508 7.94904 37.3509C7.92263 37.363 7.91063 37.3944 7.92263 37.4219C7.93463 37.4485 7.96744 37.4606 7.99305 37.4485C8.17308 37.3654 8.33871 37.4178 8.34031 37.4178C8.35232 37.4219 8.36512 37.4211 8.37632 37.4162Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.80996 38.2554C8.65793 38.2554 8.59152 38.1505 8.57711 38.0859C8.57471 38.0746 8.57711 38.0633 8.58191 38.0529C8.69074 37.8681 8.64113 37.6301 8.64033 37.6277C8.63472 37.6035 8.64993 37.5793 8.67393 37.5744C8.69794 37.5688 8.72194 37.5841 8.72674 37.6083C8.72914 37.6188 8.78195 37.8689 8.66833 38.0811C8.68193 38.115 8.72994 38.1876 8.86997 38.1593C8.89478 38.1545 8.91798 38.1698 8.92278 38.1948C8.92758 38.2191 8.91238 38.2433 8.88757 38.2481C8.85877 38.2537 8.83316 38.2562 8.80916 38.2562L8.80996 38.2554Z",
					fill: "#EDA89D"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask3_5402_211896",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 46,
			width: 9,
			height: 10,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.1771 46.8164H5.66602V55.3678H13.1771V46.8164Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask3_5402_211896)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.4403 45.8384H4.79297V55.5128H13.4403V45.8384Z",
					fill: "url(#paint8_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.96545 50.1314C7.96545 50.1314 7.85823 49.9306 7.7526 49.9991C7.48455 50.1726 7.7118 50.4485 7.87423 50.5195L7.96545 50.1314Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.97281 49.4287H7.97441C7.97521 49.4094 7.97681 49.3892 7.97841 49.369C8.05842 48.4824 8.86498 47.8377 9.75156 47.9789C10.4901 48.0967 11.0446 48.7486 11.0462 49.503C11.0462 49.7829 10.975 50.0427 10.8502 50.2662C10.6757 50.6139 10.5229 50.9117 10.3677 51.1561C10.1108 51.5603 9.9972 52.0412 10.034 52.5204L10.0628 52.8972C9.07622 53.3159 8.68975 52.8069 8.68975 52.8069L8.73376 52.1243C8.73936 52.0355 8.67614 51.9573 8.58893 51.9436H8.58733C7.4279 51.7596 7.9248 49.958 7.97281 49.4287Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.47716 50.3833C9.48436 50.3042 9.55398 50.2453 9.63239 50.2526C9.71081 50.2598 9.76922 50.33 9.76202 50.4091C9.75482 50.4881 9.6852 50.547 9.60679 50.5398C9.52837 50.5325 9.46996 50.4623 9.47716 50.3833Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.23302 50.0112C8.24022 49.9321 8.30984 49.8732 8.38825 49.8805C8.46667 49.8877 8.52508 49.9579 8.51788 50.037C8.51068 50.1161 8.44106 50.175 8.36265 50.1677C8.28423 50.1605 8.22582 50.0903 8.23302 50.0112Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.0072 50.2063C10.0216 50.2079 10.0368 50.2055 10.0512 50.1982C10.0928 50.178 10.1104 50.1272 10.0904 50.0853C10.0296 49.9586 9.82712 49.7537 9.49345 49.8852C9.45024 49.9021 9.42944 49.9513 9.44624 49.9949C9.46305 50.0385 9.51186 50.0594 9.55506 50.0425C9.82872 49.9344 9.93514 50.1498 9.93994 50.1587C9.95354 50.1861 9.97915 50.2039 10.008 50.2063H10.0072Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.69172 49.8586C8.70613 49.8602 8.72133 49.8578 8.73573 49.8506C8.77734 49.8304 8.79494 49.7796 8.77494 49.7376C8.71413 49.6109 8.51169 49.406 8.17802 49.5375C8.13481 49.5545 8.11401 49.6037 8.13081 49.6472C8.14762 49.6908 8.19643 49.7118 8.23963 49.6948C8.51329 49.5867 8.61971 49.8022 8.62451 49.811C8.63811 49.8385 8.66372 49.8562 8.69252 49.8586H8.69172Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.167 49.7692L10.6573 50.7752L10.3845 50.6938L10.3389 49.3311L11.167 49.7692Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.3441 50.6569C10.3737 50.6093 10.4201 50.5754 10.4729 50.5593C10.5825 50.5262 10.773 50.4964 10.8898 50.6375C11.061 50.8441 10.637 51.312 10.2857 51.028C10.2857 51.028 10.1889 50.9102 10.3441 50.6577V50.6569Z",
					fill: "#FFCDC4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.69756 50.8366C8.82798 50.9165 8.95681 50.8535 8.95841 50.8527C8.97041 50.8463 8.97521 50.8317 8.96961 50.8188C8.96321 50.8067 8.94881 50.8011 8.936 50.8075C8.9304 50.8108 8.78717 50.8793 8.66235 50.7422C8.64235 50.7196 8.63194 50.7027 8.63274 50.6897C8.63354 50.6728 8.65595 50.6526 8.68715 50.6244C8.75837 50.5598 8.87759 50.4517 8.9352 50.1887C8.9384 50.175 8.9296 50.1621 8.916 50.1589C8.9024 50.1556 8.88959 50.1645 8.88639 50.1782C8.83198 50.4259 8.72476 50.5227 8.65355 50.5873C8.61514 50.622 8.58473 50.6494 8.58313 50.6873C8.58153 50.7148 8.59514 50.7422 8.62554 50.7761C8.64875 50.8019 8.67355 50.8213 8.69756 50.8366Z",
					fill: "#EDA89D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.27326 48.8518C8.27326 48.8518 8.03962 48.9873 7.90039 49.9192C7.90039 49.9192 7.91959 48.8679 8.04522 48.7638C8.17084 48.6598 8.27246 48.8518 8.27246 48.8518H8.27326Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1447 52.7114H8.61325L8.01953 55.3005V60.2672C8.01953 60.2672 9.42541 60.9538 11.277 60.0558L10.7369 54.2436L10.1447 52.7114Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1453 52.7117C10.1453 52.7117 12.457 53.6977 12.9107 54.3318C13.33 54.9176 13.2715 54.3609 14.479 57.647C14.6366 58.077 14.5678 58.5498 14.3109 58.9113C14.2061 59.0589 14.0565 59.1694 13.8877 59.2324L12.697 59.6801L12.8227 62.7323L10.5166 62.9614L10.1445 52.7109L10.1453 52.7117Z",
					fill: "#83CAF9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.61298 52.7114C8.61298 52.7114 6.30133 53.6973 5.84764 54.3315C5.39315 54.9656 5.93486 62.7328 5.93486 62.7328L8.24091 62.9619L8.61298 52.7114Z",
					fill: "#83CAF9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.64788 53.0022L9.37823 53.4645L9.93994 60.0036L9.07417 61.4123L8.43164 59.9681L9.05416 53.4249L8.85732 52.9626L9.38543 52.7642L9.64788 53.0022Z",
					fill: "url(#paint9_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1456 52.7115L10.0304 52.4573L9.31022 52.7115L8.7141 52.4355L8.61328 52.7115L8.74051 53.1867L9.28381 52.8309L9.81432 53.2198L10.1456 52.7115Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6447 47.9085C10.6007 47.8633 10.5199 47.8262 10.4823 47.8778C10.4671 47.8988 10.4671 47.9262 10.4687 47.952C10.4743 48.0263 10.4919 48.0997 10.5199 48.1675C10.2615 47.8625 9.83099 47.7673 9.43331 47.7737C9.03563 47.7802 8.64035 47.8673 8.24268 47.848C8.08504 47.8399 7.89621 47.8286 7.80339 47.9577C7.73858 48.0472 7.75378 48.1788 7.81859 48.2691C7.88341 48.3587 7.98823 48.4119 8.09545 48.4386C8.01303 48.4039 7.91061 48.4273 7.8514 48.4942C7.79219 48.5612 7.78179 48.6669 7.82579 48.7451C7.89381 48.8645 8.04984 48.8904 8.18506 48.9017C8.61715 48.9372 9.05083 48.9501 9.48452 48.9388C9.42131 48.9904 9.35889 49.0412 9.29568 49.0929C9.27408 49.1106 9.25167 49.1292 9.24127 49.155C9.22687 49.1905 9.23967 49.2316 9.26047 49.2639C9.31329 49.347 9.4157 49.3874 9.51332 49.3938C9.61094 49.4003 9.70856 49.3777 9.80538 49.3623C9.94701 49.3389 10.0902 49.3293 10.2335 49.3325C10.2631 49.3325 10.2935 49.3349 10.3207 49.347C10.3567 49.364 10.3807 49.3986 10.4063 49.4301C10.5591 49.6149 10.8008 49.6939 11.0288 49.7633C11.1 49.7851 11.1937 49.7988 11.2329 49.7359C11.2481 49.7117 11.2505 49.681 11.2513 49.652C11.2625 49.3059 11.1792 48.9565 11.012 48.654C11.0552 48.7314 11.16 48.7508 11.2081 48.6604C11.2689 48.545 11.1248 48.4498 11.044 48.4031C10.9704 48.3595 10.9 48.3506 10.8448 48.278C10.7584 48.1642 10.7496 48.0198 10.6431 47.9101L10.6447 47.9085Z",
					fill: "#121729"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.0824 51.2135L8.27344 51.0166C8.27344 51.0166 8.31985 51.4692 8.6143 51.4692C8.90876 51.4692 9.0832 51.2143 9.0832 51.2143L9.0824 51.2135Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.0465 53.1277L10.5928 55.0141L11.0465 55.2053L10.3776 59.1159L10.1455 52.7114L11.0465 53.1277Z",
					fill: "url(#paint10_linear_5402_211896)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.71191 53.1277L8.1656 55.0141L7.71191 55.2053L8.38005 59.1159L8.61289 52.7114L7.71191 53.1277Z",
					fill: "url(#paint11_linear_5402_211896)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5402_211896",
				x1: 22.5295,
				y1: 713076e-10,
				x2: 22.5295,
				y2: 9.34532,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .29,
					stopColor: "#F5C91D"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F18F23"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5402_211896",
				x1: 8.44042,
				y1: 21.1435,
				x2: 9.90013,
				y2: 10.5339,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8B2682" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB2D88"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5402_211896",
				x1: 9.13557,
				y1: 31.8541,
				x2: 9.13557,
				y2: 22.1797,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3E1F87" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6E32F9"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_5402_211896",
				x1: 9.3304,
				y1: 32.3028,
				x2: 9.3304,
				y2: 28.6665,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8B2682" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB2D88"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5402_211896",
				x1: 6.94572,
				y1: 32.4493,
				x2: 6.94572,
				y2: 30.563,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8B2682" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB2D88"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_5402_211896",
				x1: 10.1356,
				y1: 42.6217,
				x2: 10.1356,
				y2: 35.2491,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8B2682" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB2D88"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_5402_211896",
				x1: 9.3304,
				y1: 43.5191,
				x2: 9.3304,
				y2: 39.8828,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#606386" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#1A1D2D"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_5402_211896",
				x1: 9.25704,
				y1: 37.989,
				x2: 9.25704,
				y2: 35.2668,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8B2682" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB2D88"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_5402_211896",
				x1: 9.11701,
				y1: 55.5128,
				x2: 9.11701,
				y2: 45.8384,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3E1F87" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6E32F9"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint9_linear_5402_211896",
				x1: 9.18539,
				y1: 61.4123,
				x2: 9.18539,
				y2: 52.7642,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8B2682" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DB2D88"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint10_linear_5402_211896",
				x1: 10.596,
				y1: 59.1159,
				x2: 10.596,
				y2: 52.7114,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#606386" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#1A1D2D"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint11_linear_5402_211896",
				x1: 8.1624,
				y1: 59.1159,
				x2: 8.1624,
				y2: 52.7114,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#606386" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#1A1D2D"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgCustomerListGroup);
export { ForwardRef as ReactComponent };
